import { Box, Stack, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { useCurrency } from '~/features/internationalization/hooks/use-currency';
import { usePricePlans } from '~/features/plans/hooks/use-price-plans';
import { FALLBACK_MONTHLY_PRICE } from '~/features/reimbursement/utils/email-templates';

import { BusinessPlanSection } from './business-plan-section';
import { EmailEmployerSection } from './email-employer-section';
import { ReceiptSection } from './receipt-section';
import { ReimbursementHeroSection } from './reimbursement-hero-section';

export function ReimbursementPage() {
  const { currency } = useCurrency();
  const { data: pricePlans } = usePricePlans(currency);
  const monthlyPrice = pricePlans?.prices?.monthly?.individual?.displayPrice ?? FALLBACK_MONTHLY_PRICE;

  return (
    <>
      <ReimbursementHeroSection />
      <Box backgroundColor='grey.100' paddingY={{ base: 10, md: 20 }}>
        <ContentContainer contentMaxWidth='content-max-width-md'>
          <Text
            fontSize='18px'
            lineHeight='1.5'
            marginBottom={{ base: 8, md: 12 }}
            marginX='auto'
            maxWidth='826px'
            textAlign='center'
          >
            Many companies will help your career growth through professional education reimbursement. Learn how to talk
            with your employer to expense a Udacity subscription.
          </Text>
          <Stack backgroundColor='white' borderRadius='6px' gap={{ base: 12, md: 14 }} padding={{ base: 6, md: 14 }}>
            <ReceiptSection />
            <EmailEmployerSection monthlyPrice={monthlyPrice} />
            <BusinessPlanSection />
          </Stack>
        </ContentContainer>
      </Box>
    </>
  );
}
